import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { RedefinirSenhaDTO } from 'src/app/entity/RedefinirSenhaDTO';
import { AuthService } from 'src/app/service/autenticacao/auth.service';
import { PAGINA_LOGIN } from 'src/app/tools/URL';
import { NOVA_SENHA_OBRIGATORIA, CONFIRMACAO_NOVA_SENHA_OBRIGATORIA, SENHA_DIFERENTE, QUERY_VAZIA } from '../../../tools/Mensagens';
import {  AbstractControl,  FormBuilder,  FormControl,  FormGroup,  Validators,} from '@angular/forms';

@Component({
  selector: 'redefinir-senha',
  templateUrl: './redefinir-senha.component.html',
  styleUrls: ['./redefinir-senha.component.css']
})
export class RedefinirSenhaComponent implements OnInit {

  urlLogin = PAGINA_LOGIN;
  redefinirSenhaDTO = new RedefinirSenhaDTO();

  novaSenha = new FormControl(null, [
    (c: AbstractControl) => Validators.required(c),
    Validators.pattern(
      /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*()_+-.={}|:;"'<>,?/]).{8,}/
    ),
  ]);
  confirmacaoSenha = new FormControl(null, [
    (c: AbstractControl) => Validators.required(c),
    Validators.pattern(
      /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*()_+-.={}|:;"'<>,?/]).{8,}/
    ),
  ]);

  redefinirSenha = this.formBuilder.group(
    {
      novaSenha: this.novaSenha,
      confirmacaoSenha: this.confirmacaoSenha,
    },
    {
      validator: this.ConfirmedValidator('novaSenha', 'confirmacaoSenha'),
    }
  );

  ConfirmedValidator(controlName: string, matchingControlName: string) {
    return (formGroup: FormGroup) => {
      const control = formGroup.controls[controlName];
      const matchingControl = formGroup.controls[matchingControlName];
      if (
        matchingControl.errors &&
        !matchingControl.errors.confirmedValidator
      ) {
        return;
      }
      if (control.value !== matchingControl.value) {
        matchingControl.setErrors({ confirmedValidator: true });
      } else {
        matchingControl.setErrors(null);
      }
    };
  }


  constructor(
      private authService: AuthService,
      private activatedRoute: ActivatedRoute,
      private formBuilder: FormBuilder
    ) {}

  ngOnInit() {
    this.redefinirSenhaDTO.novaSenha = null;
    this.redefinirSenhaDTO.confirmacaoSenha = null;
    this.activatedRoute.queryParamMap
      .subscribe(params => {
        this.redefinirSenhaDTO.idUsuario = params.get('query');
      });
  }

  camposVazios() {

    return (this.redefinirSenhaDTO.novaSenha === null || this.redefinirSenhaDTO.novaSenha === '') &&
    (this.redefinirSenhaDTO.confirmacaoSenha === null || this.redefinirSenhaDTO.confirmacaoSenha === '');

  }

  camposValidos(redefinirSenhaDTO) {

    if (redefinirSenhaDTO.idUsuario === null || redefinirSenhaDTO.idUsuario === undefined || redefinirSenhaDTO.idUsuario === '') {

      alert(QUERY_VAZIA);

      return false;

    }

    if (redefinirSenhaDTO.novaSenha === null || redefinirSenhaDTO.novaSenha === '') {

      alert(NOVA_SENHA_OBRIGATORIA);

      return false;

    }

    if (redefinirSenhaDTO.confirmacaoSenha === null || redefinirSenhaDTO.confirmacaoSenha === '') {

      alert(CONFIRMACAO_NOVA_SENHA_OBRIGATORIA);

      return false;

    }

    if (redefinirSenhaDTO.novaSenha !== redefinirSenhaDTO.confirmacaoSenha) {

      alert(SENHA_DIFERENTE);

      return false;

    }

    return true;

  }

  enviar() {

    if (this.camposValidos(this.redefinirSenhaDTO)) {

      this.authService.redefinirSenha(this.redefinirSenhaDTO);

    }

  }

}
